import _ from 'underscore';
import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getBaseStepLayoutStyles } from './styles/step-base-layout-styles';
import { StepFooter } from './step-base-layout-footer';

/**
 * Base layout for wizard steps. Includes header and footer.
 * @param {*} props - See propTypes definition.
 * @returns {ReactNode} - Base layout component.
 */
export function StepBaseLayout(props) {
  const {
    children,
    className,
    stepContainerClassName,
    stepContentContainerClassName,
    mainSideClassName,
    nextButtonText,
    previousButtonText,
    cancelButtonText,
    onCancelClick,
    onNextClick,
    onPreviousClick,
    onSkippingLinkClick,
    skippingLinkTitle,
    title,
    onRenderFooterNote,
    onRenderRightSide,
    isPreviousClickDisabled,
    isNextClickDisabled,
    isSkipLinkDisabled,
    isHideFooter,
  } = props;

  const classes = useDefaultStyles(getBaseStepLayoutStyles);
  return (
    <div className={classNames('step', className, stepContainerClassName || classes.stepContainer)}>
      <div className={classNames('step-content', className, stepContentContainerClassName || classes.stepContentContainer)}>
        <div className={classNames(mainSideClassName || classes.mainSide)}>
          {title && <div className="step-header"><h1>{title}</h1></div>}

          <div className="step-primary-content">
            {children}
          </div>
        </div>

        {
          _.isFunction(onRenderRightSide) && onRenderRightSide()
        }
      </div>

      {!isHideFooter && <StepFooter
        onCancelClick={onCancelClick}
        onPreviousClick={onPreviousClick}
        onNextClick={onNextClick}
        onSkippingLinkClick={onSkippingLinkClick}
        skippingLinkTitle={skippingLinkTitle}
        onRenderFooterNote={onRenderFooterNote}

        cancelButtonText={cancelButtonText}
        previousButtonText={previousButtonText}
        nextButtonText={nextButtonText}
        isPreviousClickDisabled={isPreviousClickDisabled}
        isNextClickDisabled={isNextClickDisabled}
        isSkipLinkDisabled={isSkipLinkDisabled}
      />}
    </div>
  );
}

StepBaseLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  className: PropTypes.string,
  stepContainerClassName: PropTypes.string,
  stepContentContainerClassName: PropTypes.string,
  mainSideClassName: PropTypes.string,

  onPreviousClick: PropTypes.func,
  onNextClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onCancelClick: PropTypes.func,
  onSkippingLinkClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  skippingLinkTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onRenderFooterNote: PropTypes.func,

  cancelButtonText: PropTypes.string,
  previousButtonText: PropTypes.string,
  nextButtonText: PropTypes.string,
  isPreviousClickDisabled: PropTypes.bool,
  isNextClickDisabled: PropTypes.bool,
  isSkipLinkDisabled: PropTypes.bool,

  title: PropTypes.string,
  onRenderRightSide: PropTypes.func,
  isHideFooter: PropTypes.bool,
};

StepBaseLayout.defaultProps = {
  children: null,
  className: null,
  stepContainerClassName: undefined,
  stepContentContainerClassName: undefined,
  mainSideClassName: undefined,

  title: null,
  onRenderRightSide: null,

  skippingLinkTitle: null,
  onPreviousClick: null,
  onNextClick: null,
  onCancelClick: null,
  onSkippingLinkClick: null,
  onRenderFooterNote: null,

  cancelButtonText: null,
  previousButtonText: null,
  nextButtonText: null,
  isPreviousClickDisabled: false,
  isNextClickDisabled: false,
  isSkipLinkDisabled: false,
  isHideFooter: false,
};
